export default "__VITE_ASSET__BUzuUs_N__"